import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import LumenNavbar from "../../layout/LumenNavbar";
import NewFooter from "../../layout/NewFooter";
import LumenButton from "../../ui/LumenButton";
import { s3_url } from "common/constants";
import "./NewAboutPage.css";

const NewAboutPage: React.FC = () => {
  return (
    <>
      <LumenNavbar />
      <div className="about-us about-page">
        <section className="about-hero" aria-label="O nama - naslovna slika">
          <div
            className="about-hero-bg"
            style={{ backgroundImage: `url(${s3_url}/about-us/1.webp)` }}
            role="img"
            aria-label="Lumen tim"
          />

          <div className="about-hero-red-circle" aria-hidden="true" />

          <div className="about-hero-bubble">
            <h1 className="about-title">O NAMA</h1>
            <p className="about-hero-intro">
              Naša priča započela je prije 30 godina kada je Karmen Dasović,
              profesorica matematike i fizike, odlučila svoju ljubav prema
              matematici i fizici te djeci i podukama prenijeti učenicima kroz
              osnivanje škole za poduke Lumen. Svaki početak je težak, pa se
              tako i Karmen susrela s mnogim preprekama, ali bila je ustrajna u
              svom cilju.
            </p>
          </div>

          <div className="top-circles" aria-hidden="true">
            <div className="top-circle top-circle-2" />
            <div className="top-circle top-circle-4" />
          </div>
        </section>

        <section className="about-mobile-text d-lg-none">
          <Container>
            <p className="about-hero-intro-mobile">
              Naša priča započela je prije 30 godina kada je Karmen Dasović,
              profesorica matematike i fizike, odlučila svoju ljubav prema
              matematici i fizici te djeci i podukama prenijeti učenicima kroz
              osnivanje škole za poduke Lumen. Svaki početak je težak, pa se
              tako i Karmen susrela s mnogim preprekama, ali bila je ustrajna u
              svom cilju.
            </p>
            <div
              className="top-circle top-circle-4 mobile-circle-4"
              aria-hidden="true"
            />
          </Container>
        </section>

        <section className="about-section">
          <Container>
            <Row className="align-items-center g-4">
              <Col lg={5} className="order-2 order-lg-1">
                <p className="lead-text quote enhanced-quote push-right">
                  Kada radiš ono što voliš, svaki problem ima rješenje – a
                  Karmen doista radi posao koji voli.
                </p>
              </Col>
              <Col lg={7} className="order-1 order-lg-2 text-center">
                <img
                  src={`${s3_url}/about-us/2.webp`}
                  className="circle-img xxl"
                  alt="Naš tim"
                  loading="lazy"
                />
              </Col>
            </Row>
          </Container>
        </section>

        <section className="about-card-section">
          <Container>
            <div className="about-card gradient">
              <Row className="align-items-center g-4">
                <Col md={4} className="text-center">
                  <img
                    src={`${s3_url}/about-us/3.webp`}
                    className="circle-img lg"
                    alt="Naš pristup"
                    loading="lazy"
                  />
                </Col>
                <Col md={8}>
                  <p className="card-text">
                    Kroz život je uvijek lakše koračati s nekim tko razumije
                    izazove. U Lumenu smo zajednica koja brine – jasna pravila,
                    topli pristup i osmijeh na licu. Jasna marljivo vodi računa
                    o svim logističkim i organizacijskim poslovima u našem
                    obrtu; pronaći će najbolji termin za svakog učenika,
                    dočekati ga s osmijehom i ohrabriti lijepom riječju.
                  </p>
                </Col>
              </Row>

              <img
                src={`${s3_url}/homepage/knjige.webp`}
                className="books-sticker"
                alt=""
                aria-hidden="true"
                loading="lazy"
              />
            </div>
          </Container>
        </section>

        <section className="about-split">
          <Container>
            <Row className="g-5 align-items-center">
              <Col lg={6}>
                <p className="lead-text kako-text">
                  Kako posao raste, tako se širi i Lumen obitelj. Svoje prve
                  prostore na Kantridi zamijenili smo prostorima u centru
                  Rijeke. Kroz godine, na vratima Lumena, na adresi Fiorella la
                  Guardia 12, pokucalo je nebrojeno generacija pripremajući se
                  za ispite iz raznih predmeta, savladavajući gradivo,
                  pripremajući se za državnu maturu. Tako je obitelj Lumena iz
                  godine u godinu rasla.
                </p>
              </Col>
              <Col lg={6}>
                <div className="quote-circle">
                  KVALITETA I RAD SE PREPOZNAJU, PA JE KARMEN VIŠE GODINA
                  ZAREDOM PROGLAŠENA JEDNOM OD NAJUSPJEŠNIJIH PODUZETNICA
                </div>
              </Col>
            </Row>
          </Container>

          <div className="split-little-circles" aria-hidden="true">
            <span className="split-dot sd-top-left" />
            <span className="split-dot sd-bottom-left" />
          </div>
        </section>

        <section className="about-gallery tight-bottom">
          <Container fluid className="px-0">
            <div className="about-gallery-row">
              <img
                src={`${s3_url}/about-us/4.webp`}
                alt="Lumen"
                loading="lazy"
              />
              <img
                src={`${s3_url}/about-us/5.webp`}
                alt="Lumen"
                loading="lazy"
              />
            </div>
          </Container>
        </section>

        <section className="about-band no-gap-top">
          <Container>
            <Row className="align-items-center">
              <Col lg={6} className="order-2 order-lg-1 mt-4 mt-lg-0">
                <div className="band-copy">
                  Dokaz da smo svi zajedno velika Lumen obitelj je i sama
                  činjenica da su mnogi učenici Lumena postali nastavnici
                  Lumena. Ponovno je pokucala na naša vrata 2015. godine Mia
                  Černivec, sada u ulozi profesorice matematike i informatike.
                  Mlada profesorica, puna novih ideja, unijela je novu energiju
                  u naš tim. Krenuli smo u modernizaciju radnih materijala i sve
                  više se okrenuli digitalnom dobu. Upravo ona će voditi projekt
                  Lumen@home i biti vam podrška na našoj web platformi.
                </div>
              </Col>
              <Col lg={6} className="order-1 order-lg-2 text-center">
                <img
                  src={`${s3_url}/about-us/8.webp`}
                  className="circle-img band-portrait"
                  alt="Mia Černivec"
                  loading="lazy"
                />
              </Col>
            </Row>
          </Container>
        </section>

        <section className="about-closing">
          <Container>
            <Row className="align-items-center g-4">
              <Col lg={5} className="text-center">
                <img
                  src={`${s3_url}/about-us/lumen-kauc.webp`}
                  alt="Lumenko na kauču"
                  className="lumenko overlap-up"
                  loading="lazy"
                />
              </Col>
              <Col lg={7}>
                <p className="lead-text">
                  S obzirom na to da obitelj nije propisana formulama,
                  jednadžbama, periodnim sustavom elemenata ili mjestom
                  stanovanja, Karmen je sa svojim timom nastavnika odlučila
                  svoju priču proširiti na cijelu Hrvatsku pružajući učenicima
                  mogućnost online pripreme za državnu maturu kroz projekt
                  Lumen@home, čime ih poziva u jednu veliku, nasmijanu obitelj
                  punu podrške koja postoji već 30 godina.
                </p>
                <LumenButton
                  to="/poduke/rezervacija"
                  className="about-cta-btn"
                  size="lg"
                >
                  REZERVIRAJ TERMIN
                </LumenButton>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      <NewFooter />
    </>
  );
};

export default NewAboutPage;
